import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "test-write"
}
const _hoisted_2 = {
  key: 1,
  class: "test-write__textarea p-3"
}
const _hoisted_3 = { class: "test-write__info p-3" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Скорость", -1)
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Точность", -1)
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Прошедшее время", -1)
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, " Функции ", -1)
const _hoisted_13 = ["onClick"]

import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import TextWriteInput from "@/components/TestWriteWindow/_components/TextWriteRender.vue";

import {
  startStopwatch,
  restartStopwatch,
  stopStopwatch,
  timeInMinute,
  time
} from "@/components/TestWriteWindow/_composibles/stopwatch"
import Loader from "@/components/loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextWriteWindow',
  props: {
    text: {},
    isLoading: { type: Boolean }
  },
  emits: ["backToForm"],
  setup(__props: any, { emit }) {

const props = __props;





// Обработка нажатого символа
let indexCurrentChar = ref(0)
let invalidChar = ref(false)
let computedCurrentChar = computed(() => {
  return props.text[indexCurrentChar.value]
})
let errorCounter = ref(0)

const listServiceKeys = ['shift', 'capslock', 'enter', 'control', 'alt', 'backspace']

function onKeyupKeyboard(e: KeyboardEvent) {
  // TODO: Исправить TS, чтобы не выдвал ошибку на array.prototype.at
  if (indexCurrentChar.value >= props.text.length - 1) {
    stopStopwatch()
  }

  let isServiceKey = !!~listServiceKeys.findIndex((key) => e.key.toLowerCase() === key)
  if (isServiceKey) return

  if (e.key != computedCurrentChar.value && !(e.key === '-' && computedCurrentChar.value === '—')) {
    invalidChar.value = true
    errorCounter.value++
    return
  }

  invalidChar.value = false

  indexCurrentChar.value++
}

// Конец обработки нажатия


watch(() => props.text, () => {
  if (props.text.length) startStopwatch()
});

// Хуки
onMounted(() => {
  document.addEventListener('keydown', onKeyupKeyboard)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onKeyupKeyboard)
})

// Расчет скорости ввода
const charPerMin = computed(() => {
  let value: number = +indexCurrentChar.value / timeInMinute.value
  return value.toFixed()
})


// Расчет точности вводимой информации
const accuracyWriting = computed(() => {
  return (100 - (errorCounter.value * 100) / props.text.length).toFixed(1)
})

// Конец расчета очности вводимой информации
function backToForm(e: MouseEvent) {
  stopStopwatch()
  emit('backToForm', e)
}

function restart() {
  indexCurrentChar.value = 0
  invalidChar.value = false
  errorCounter.value = 0
  if (props.text.length) restartStopwatch()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          "is-fullscreen-loader": ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.text.length)
            ? (_openBlock(), _createBlock(TextWriteInput, _mergeProps({
                key: 0,
                class: "test-write__textarea p-3"
              }, {
            text: _ctx.text,
            invalidChar: _unref(invalidChar),
            indexCurrentChar: _unref(indexCurrentChar)
          }), null, 16))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, " Произошла ошибка запроса данных, попробуйте позже ")),
          _createElementVNode("aside", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, _toDisplayString(charPerMin.value) + " зн./мин ", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(accuracyWriting.value) + " % ", 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(_unref(time)) + " с. ", 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link",
                tabindex: "-1",
                onKeyup: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onClick: _withModifiers(restart, ["left"])
              }, " Заново ", 40, _hoisted_13),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link",
                tabindex: "-1",
                onClick: backToForm
              }, " Назад ")
            ])
          ])
        ]))
  ]))
}
}

})